// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3SYhE","notes":"Notes_notes__wVKRK"};